export default {"src":"/_next/static/media/trip-assistance.ca6763b7.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};